'use client';

import { useState } from 'react';
import { Search } from 'lucide-react';
import Link, { useRouter } from '@/core/i18n/navigation';
import { useTranslation } from '@/core/hooks/useTranslation';

export default function StoreNotFound() {
    const { t } = useTranslation();
    const router = useRouter();
    const [query, setQuery] = useState('');

    const search = (e: React.FormEvent) => {
        e.preventDefault();
        const q = query.trim();
        router.push(q ? `/produkty?q=${encodeURIComponent(q)}` : '/produkty');
    };

    return (
        <section className="w-full px-4 py-16 sm:py-24">
            <div className="mx-auto max-w-xl text-center">
                <p className="text-sm font-bold uppercase tracking-wider" style={{ color: 'var(--primary)' }}>404</p>
                <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight">
                    {t('not_found.title', 'Nie znaleźliśmy tej strony')}
                </h1>
                <p className="mt-4 text-base opacity-75">
                    {t('not_found.text', 'Strona nie istnieje albo została przeniesiona. Wyszukaj produkt lub przejdź do sklepu.')}
                </p>
                <form onSubmit={search} className="mt-8 flex gap-2" role="search">
                    <label className="sr-only" htmlFor="not-found-search">{t('filters.search_placeholder', 'Szukaj produktów…')}</label>
                    <div className="relative flex-1">
                        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50" />
                        <input id="not-found-search" type="search" value={query} onChange={(e) => setQuery(e.target.value)}
                            placeholder={t('filters.search_placeholder', 'Szukaj produktów…')}
                            className="h-11 w-full rounded-lg border border-slate-300 bg-white pl-9 pr-3 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-300" />
                    </div>
                    <button type="submit" className="h-11 rounded-lg px-5 text-sm font-bold text-white hover:opacity-90"
                        style={{ backgroundColor: 'var(--primary)' }}>
                        {t('not_found.search', 'Szukaj')}
                    </button>
                </form>
                <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
                    <Link href="/" className="h-11 inline-flex items-center justify-center rounded-lg border border-current px-5 text-sm font-bold hover:opacity-80">
                        {t('not_found.home', 'Strona główna')}
                    </Link>
                    <Link href="/produkty" className="h-11 inline-flex items-center justify-center rounded-lg border border-current px-5 text-sm font-bold hover:opacity-80">
                        {t('not_found.products', 'Wszystkie produkty')}
                    </Link>
                </div>
            </div>
        </section>
    );
}
